import {
    LOGOUT,
    RECEIVE_PREMIUM_SETTINGS_DAMAGES,
    REQUEST_PREMIUM_SETTINGS_DAMAGES, FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES, RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN,
    RECEIVE_APPLICATION_DAMAGES,
} from "../actions/index";
import _ from 'lodash';

const defaultState = {
	damages: [],
	damagesSortOrders: [],
	applicationDamages: [],
	fetchingDamages: false
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_PREMIUM_SETTINGS_DAMAGES:
			return {
				...state,
				fetchingDamages: true
			};
		case RECEIVE_PREMIUM_SETTINGS_DAMAGES:
			return {
				...state,
				damages: _.sortBy(action.payload, ['sortOrder']),
                damagesSortOrders: _.sortBy(action.payload, ['sortOrder']).map(item => item.sortOrder),
				fetchingDamages: false
			};
        case RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN:
            return {
                ...state,
                damages: _.sortBy(action.payload.damages, ['sortOrder']),
                damagesSortOrders: _.sortBy(action.payload.damages, ['sortOrder']).map(item => item.sortOrder),
                fetchingDamages: false
            };
        case RECEIVE_APPLICATION_DAMAGES:
            return {
                ...state,
                applicationDamages: _.sortBy(action.payload, ['sortOrder'])
            };
		case FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES:
			return {
				...state,
				fetchingDamages: false
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case '@@router/LOCATION_CHANGE':
			if (action.payload.location.pathname.includes('/premium-settings/edit-premium-settings') || (action.payload.pathname === '/premium-settings/new-premium-settings'))
				return {
					...defaultState,
					damages: state.damages,
				};
			return {
				...defaultState,
				damages: state.damages
			};
		default :
			return state
	}
}